import { useCallback, useRef } from "react"

export const useClickOnce = () => {
  const clickedRef = useRef(false)
  clickedRef.current = false
  
  return useCallback(<T extends Function>(clickHandler: T): T => ((...args: any[]) => {
    if (clickedRef.current) { return }
    clickedRef.current = true
    return clickHandler(...args)
  }) as any, [])
}